export default "__VITE_ASSET__DxWvEy_e__"